/**
 * Painel de controle das secoes do dashboard.
 *
 * Para esconder uma secao do dashboard, mude `enabled` para `false`.
 * Todas as secoes habilitadas sao visiveis para qualquer usuario logado.
 */

export interface DashboardSectionConfig {
  id: string
  enabled: boolean
  label: string
  description: string
}

export const DASHBOARD_SECTIONS: DashboardSectionConfig[] = [
  // ===== SECOES DO SEGMENT DASHBOARD =====
  { id: 'resultado_principal',   enabled: true,  label: 'Resultado Principal',   description: 'Receita influenciada, ROI e % de pedidos com Widde.' },
  { id: 'valor_dos_pedidos',     enabled: false, label: 'Valor dos Pedidos',     description: 'Ticket medio com Widde vs sem Widde e diferenca percentual.' },
  { id: 'roi_por_plano',        enabled: true,  label: 'ROI por Plano',         description: 'Retorno do investimento separado por tipo de plano.' },
  { id: 'perfil_do_comprador',  enabled: true,  label: 'Perfil do Comprador',   description: 'Compradores novos vs retornantes, com e sem Widde.' },
  { id: 'ranking_roi',          enabled: true,  label: 'Ranking por ROI',       description: 'Top 5 e Bottom 5 empresas por retorno do investimento.' },
  { id: 'empresas_no_calculo',  enabled: true,  label: 'Empresas no Calculo',   description: 'Lista de empresas incluidas/excluidas do calculo.' },
]

export function isSectionVisible(id: string): boolean {
  const section = DASHBOARD_SECTIONS.find(s => s.id === id)
  return !!section && section.enabled
}
